const AIRLINE_NAME_FALLBACK_BY_CODE = {
  "6H": "Israir",
  A3: "Aegean Airlines",
  BZ: "Blue Bird Airways",
  CY: "Cyprus Airways",
  IZ: "Arkia",
  LY: "El Al",
  W6: "Wizz Air",
  FR: "Ryanair",
  U2: "easyJet",
  BA: "British Airways",
  LH: "Lufthansa",
  AF: "Air France",
  TK: "Turkish Airlines",
};

function normalizeCode(code) {
  const normalized = String(code ?? "")
    .trim()
    .toUpperCase();
  return normalized || null;
}

function toTitleCaseWords(value) {
  return String(value)
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

function normalizeAirlineName(code, rawName) {
  const name = String(rawName ?? "").trim();
  if (!name) return "";
  const fallback = AIRLINE_NAME_FALLBACK_BY_CODE[code];
  if (fallback) {
    const isSingleTokenUpper =
      !/\s/.test(name) && /^[A-Z0-9&/\-]+$/.test(name);
    if (isSingleTokenUpper) return fallback;
  }
  const looksAllUpper = /^[A-Z0-9\s&/\-]+$/.test(name);
  if (looksAllUpper) return toTitleCaseWords(name);
  return name;
}

export function buildAirlineNameMap(airlines) {
  const map = {};
  if (Array.isArray(airlines)) {
    for (const row of airlines) {
      const code = normalizeCode(row?.code);
      const name = normalizeAirlineName(code, row?.name);
      if (!code || !name) continue;
      map[code] = name;
    }
  }
  for (const [code, fallbackName] of Object.entries(AIRLINE_NAME_FALLBACK_BY_CODE)) {
    if (!map[code]) map[code] = fallbackName;
  }
  return map;
}

export function airlineDisplayNameFromCode(code, airlineNameMap) {
  const normalized = normalizeCode(code);
  if (!normalized) return "—";
  const mapped = airlineNameMap?.[normalized];
  return mapped && String(mapped).trim() !== "" ? mapped : normalized;
}

